import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { LoginPUBFormSchema, LoginPUBMutation } from './LoginPUBForm.types';
import { getLoginPUBForm } from './LoginPUBForm.schema';
import { useMutation, useQueryClient } from 'react-query';
import { loginCommercialFormData } from './LoginPUBForm.data';
import { Link, useNavigate } from 'react-router-dom';
import Form from '../../../../commons/Form/Form';
import { LOGIN_PUB_QUERY_KEY, loginPUBQuery } from './LoginPUBForm.query';
import { useState } from 'react';
import LoginPUBModal from '../LoginPUBModal/LoginPUBModal';
import { setProfile } from '../../../../../store/authentication/authenticationActions/authenticationActions';
import { UserRoles } from '../../../../../types/models/user/user.types';
import { api } from '../../../../../utils/api/api';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { useCookies } from 'react-cookie';

export default () => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [, setCookie] = useCookies(['token']);

  const IS_ACTUAL_LOGIN_ENABLED = true;

  const [isModalOpen, setModalOpen] = useState(false);

  const formProps = useForm<LoginPUBFormSchema>({
    resolver: yupResolver(getLoginPUBForm),
    mode: 'onChange',
    reValidateMode: 'onChange',
  });

  const { handleSubmit } = formProps;

  const { mutate } = useMutation<Awaited<ReturnType<LoginPUBMutation>>, Error, LoginPUBFormSchema>(
    (data) => loginPUBQuery(data),
    {
      mutationKey: LOGIN_PUB_QUERY_KEY,
      onMutate: () => queryClient.cancelMutations(),
      onSuccess: ({ user, accessToken }) => {
        if (IS_ACTUAL_LOGIN_ENABLED) {
          setProfile({ ...user, role: UserRoles.AcheteurPublic })(dispatch);
          api.setHeader('authorization', `Bearer ${accessToken}`);
          setCookie('token', accessToken, {
            expires: moment().add(60, 'minutes').toDate(),
            path: '/',
          });
          navigate('/dashboard');
        } else {
          setModalOpen(true);
        }
        //Temporary message
        // setModalOpen(true)
        // Real login
        // setProfile({ ...user, role: UserRoles.AcheteurPublic })(dispatch);
        // api.setHeader('authorization', `Bearer ${accessToken}`);
        // setCookie('token', accessToken, {
        //   expires: moment().add(60, 'minutes').toDate(),
        //   path: '/',
        // });
        // navigate('/dashboard');
      },
      onError: (error) => alert(error.message),
    }
  );

  const onSubmit = handleSubmit((data) => mutate(data));

  return (
    <>
      <Form<LoginPUBFormSchema>
        data={loginCommercialFormData}
        style={{
          width: 400,
          alignSelf: 'center',
        }}
        {...{ formProps, onSubmit }}
        afterInputsElement={
          <div className='flex-row space-between'>
            <Link to="/step_wizard/PUB">
              <span className="form__after-inputs-link text-primary">Créer un compte</span>
            </Link>
            <Link to="/password/forgot/PUB">
              <span className="form__after-inputs-link text-primary">Mot de passe oublié ?</span>
            </Link>
          </div>
        }
      />
      <LoginPUBModal isOpen={isModalOpen} setOpen={setModalOpen} closeOnClickOutside />
    </>
  );
};
